// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061848/js/" + chunkId + "." + {"44":"43ce0c51","225":"33db685c","481":"699e44f3","486":"00d0240b","770":"917af17c"}[chunkId] + ".0.13832802798168609.chunk.js";
};